export const SupportedPaymentMethods = {
  CARD: 'cards',
  PAYPAL: 'pay_pal',
  BANK: 'ebanking',
  OXXO: 'oxxo',
  AFFIRM: 'affirm',
  APPLEPAY: 'apple_pay',
  GOOGLEPAY: 'google_pay',
};

export const PaymentMethods = [
  'cards',
  'pay_pal',
  'ebanking',
  'oxxo',
  'sepa_debit',
  'ideal',
  'affirm',
  'apple_pay',
  'google_pay',
] as const;

export const SupportedGateways = {
  // @deprecated STRIPE: 'StripePlatformGateway',
  // @deprecated ADYEN: 'AdyenGateway',
  STRIPE: 'stripe',
  ADYEN: 'adyen',
};

export const Gateways = ['stripe', 'adyen'] as const;

export const Locale = [
  'ach_UG', 'ca_ES', 'de_DE', 'en_US', 'es_MX', 'fr_FR', 'id_ID', 'it_IT', 'pt_BR', 'th_TH',
] as const;

export const BillingRequredValues = {
  MANDATORY: 'mandatory',
  OPTIONAL: 'optional',
};

export const GatewayModeValues = {
  LIVE: 'live',
  TEST: 'test',
};
